import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

export const groupTripReviewApi = {
  /** 建立評價（POST，需登入） */
  create: (groupTripId, body) =>
    travelClient.post(travelEndpoints.groupTripReviews(groupTripId), body),

  /** 列出 ACTIVE 評價（公開，keyset 分頁） */
  list: (groupTripId, params) =>
    travelClient.get(travelEndpoints.groupTripReviews(groupTripId), { params }),

  /** 查詢當前會員評價資格（需登入） */
  eligibility: (groupTripId) =>
    travelClient.get(travelEndpoints.groupTripReviewEligibility(groupTripId)),

  /** 查詢當前會員的評價（需登入） */
  myReview: (groupTripId) =>
    travelClient.get(travelEndpoints.groupTripReviewMe(groupTripId)),

  /** 軟刪除評價（DELETE，需登入） */
  remove: (groupTripId, reviewId) =>
    travelClient.delete(travelEndpoints.groupTripReview(groupTripId, reviewId)),

  /** 查詢 Host 旅行信譽（公開） */
  hostReputation: (memberId) =>
    travelClient.get(travelEndpoints.memberTravelReputation(memberId)),
};
